<template>
    <div class="bg" :style="{
        'background': `url(${config.bgImageUrl}) no-repeat center/cover`,
        'backgroundColor': '#f5f5f5' // 添加备用背景色
    }">
        <div>
            <img src="../assets/img/ba.png" alt="" class="back" @click="back">
        </div>
        <div class="logo_wrap flex_center">
            <img class="logo" :src="config.logoTopImg" alt="" :style="{ 'height': config.logoTopHeight + 'px' }">
            <div class="right_top_box">
                <div class="right_top_txt">{{ $t('PoweredbyMVGX') }}</div>
                <!-- <div class="right_top_txt_shu">|</div>
          <Kefu :sn='sn'></Kefu> -->
            </div>
        </div>
        <div class="">
            <!-- <ul>
        <li class="flex_center item" v-for="(item,index) in list" :key="index" @click="helpDetail(item)">
          <div class="question">
            <div class="q">Q{{index+1}}:</div> 
            <div class="q_cont">{{item.category}}</div>
          </div>
          <i class="el-icon-arrow-right"></i>
        </li>
      </ul> -->
            <el-collapse v-model="activeName" accordion v-for="(item, index) in list" :key="index">
                <el-collapse-item :title="item.category" :name="index + 1">
                    <ul>
                        <li class="flex_center item" v-for="(item1, index1) in item.faqQuestions" :key="index1"
                            @click="helpDetail(item1)">
                            <div class="question">
                                <div class="q">Q{{ index1 + 1 }}:</div>
                                <div class="q_cont">{{ item1.title }}</div>
                            </div>
                            <i class="el-icon-arrow-right"></i>
                        </li>
                    </ul>
                </el-collapse-item>
            </el-collapse>
        </div>
    </div>
</template>
<script>
import cnt from "@/api/cnt";
import Kefu from '@/components/kefu.vue'
export default {
    components: { Kefu },
    data() {
        return {
            sn: "",
            list: [],
            activeName: '1',
            activeNameItem: '1',
            config: '',
        };
    },
    created() {
        this.sn = this.$route.query.sn;
        this.config = JSON.parse(sessionStorage.getItem('configData')) || ''
        this.getFaqList()
        // this.getTravelRecord()
        // this.getUserEvent(1,1)
    },
    mounted() {
        this.sn = this.$route.query.sn;
    },
    methods: {
        //用户行为分析
        getUserEvent(val, type) {
            let ip = localStorage.getItem('Ip')
            let ua = localStorage.getItem('Ua')
            let params = {
                event: val,
                eventType: type,
                userAgent: ua + '=' + ip,
            }
            cnt.getUserEvent(res => {
                console.log(res)
            }, params)
        },
        getFaqList() {
            cnt.getFaqList(res => {
                this.list = res.data
            })
        },
        back() {
            this.$router.go(-1)
        },
        tab(index) {
            if (index == 1) {
                var data = {
                    sn: this.sn,
                    operationName: this.Digital,
                };
            } else if (index == 2) {
                var data = {
                    sn: this.sn,
                    operationName: this.World,
                };
            }
            cnt.getWelcome((res) => {
                if (res.id == 1) {
                    this.$router.push({ path: "/trip", query: { sn: this.sn } });
                } else if (res.id == -2) {
                    // this.$message.error('Serial number does not exist')
                    this.$message.error(this.$t('Sorrythecodelinked'))
                }
            }, data);
        },
        getTravelRecord() {
            cnt.getTravelRecord(
                (res) => {
                    if (!res) {
                        this.$router.push({ path: "/result", query: { sn: this.sn } });
                    } else if (res.snStatus == 1) {
                        this.$router.push({ path: "/info", query: { sn: this.sn } });
                    } else if (res.snStatus == 2) {
                        this.$router.push({ path: "/resultCard", query: { sn: this.sn } });
                    } else if (res.snStatus == null) {
                        if (res.operationName == null) {
                            this.$router.push({ path: '/welcome', query: { sn: this.sn } })
                        } else {
                            this.$router.push({ path: '/trip', query: { sn: this.sn } })
                        }
                    }
                },
                { sn: this.sn }
            );
        },
        helpDetail(item) {
            this.$router.push("/helpDetail")
            sessionStorage.setItem('detail', JSON.stringify(item))
        }
    },
};
</script>
<style lang="less" scoped>
.bg {
    width: 100%;
    // height: 100%;
    position: absolute;
    // top: 0;
    // left: 0;
    min-height: 100%;
    background-repeat: no-repeat;
    background-size: 100% 100%;
}

.back {
    width: .8125rem;
    height: 1.375rem;
    margin: 2.5rem 1.25rem 0;
}

.logo {
    width: auto;
}

.power {
    font-size: .75rem;
    font-family: Century Gothic;
    color: #EDFFFE;
}

.flex_center {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.right_top_box {
    display: flex;
    align-items: center;

    .right_top_txt {
        font-size: 12px;
        font-family: Century Gothic;
        color: #EDFFFE;
    }

    .right_top_txt_shu {
        margin: 0 12px;
        color: #EDFFFE;
    }
}

.logo_wrap {

    margin: 1.25rem 1.25rem 2.1875rem;
}

.item {
    margin: 0 1.25rem .625rem;
    background: #FFFFFF;
    border-radius: .625rem;
    padding: 1.25rem;
}

.question {
    width: 90%;
    display: flex;
}

.q {
    margin-right: .625rem;
    color: #303236;
    font-size: .9375rem;
}

.q_cont {
    width: 87%;
    display: flex;
    flex-direction: column;
    /* white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  word-break: break-all; */
    word-wrap: break-word;
    color: #626262;
    font-size: .9375rem;
}

::v-deep .el-collapse {
    margin: 10px 20px;
    padding: 0 14px;
    background: #FFFFFF;
    border-radius: 10px;

    .el-collapse-item__content {
        padding-bottom: 0 !important;
    }

    .item {
        margin: 0;
        padding: 5px;

        // align-items: center;
        .el-icon-arrow-right {
            // transform: translateY(7px);
        }
    }
}
</style>
